import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Pipe({
  name: 'safeStyle',
  standalone: true
})
export class SafeStylePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any): SafeStyle {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
